{
    "name": "Green Bartlett Pear",
    "binomial_name": "Pyrus communis 'Williams'",
    "common_names": [
        "Williams pear",
        "Williams' Bon Chr\u00e9tien pear",
        "bartlett pear"
    ],
    "description": "Green Bartlett pears are a cultivar of the species Pyrus communis or European Pear. Bartlett pears have a bell shape and green skin that turns yellow as it ripens after harvest. Both Green and Red Bartlett pears are medium-sized and juicy with soft flesh. They can be eaten fresh, baked, or canned. Bartlett pears are not as cold tolerant as other varieties. Their white blooms open early in the season and they are ready to harvest in late summer or early fall. The pear should still be green and relatively hard when picked. After harvest, pears take 7-10 days to ripen, during which time their flesh will soften and the skin will change to a soft yellow. Bartlett pears are not self-fertile. They require pollination by a pear tree of another variety with the same bloom period within 50 feet, such as Bosc. Standard and dwarf rootstocks are available. Standard sized trees can grow to 6 meters. Depending on the size chosen, the tree will bear fruit within 4-6 years of planting.",
    "sun_requirements": "Full Sun",
    "sowing_method": "Transplant bare-root plant",
    "spread": 85,
    "row_spacing": 300,
    "height": 300,
    "growing_degree_days": 0,
    "companions": [],
    "image": "/crops/images/green-bartlett-pear.jpg",
    "icon": "/crops/icons/green-bartlett-pear.avif"
}